import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  addFolders(state, payload) {
    state.folders.push(...payload);
  },
  addLabels(state, payload) {
    state.labels.push(...payload);
  },
  setLabels(state, payload) {
    state.labels = payload;
  },
};
